import { Box, TableCell } from "@mui/material";
import StyledTableRow from "../../../components/table/styled-table-row";
import TableActionButton from "../../../components/table/table-action-button";
import { SocialDistanceIcon } from "../../../shared/icons";
import { BiometricDeviceUserRequest, BiometricTransaction } from "../../../service/model/biometric.model";
import { BiometricTransactionProcessingStatus } from "../../../shared/enums";
import { ReactNode, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { selectLoggedInUser } from "../../auth/auth.slice";
import { selectMembers } from "../../members/member.slice";
import { selectUsers } from "../../user/user.slice";
import StyledChip from "../../../components/styled-chip";

interface TableRowProps {
    readonly transaction: BiometricTransaction
}

const BiometricTransactionTableRow: React.FC<TableRowProps> = ({ transaction }) => {
    // const dispatch = useAppDispatch();
    // const members = useAppSelector(selectMembers);
    // const staff = useAppSelector(selectUsers);
    // const [showBiometricUserForm, setShowBiometricUserForm] = useState(false);
    // const loggedInUserDetails = useAppSelector(selectLoggedInUser);
    // const loggedInUser = loggedInUserDetails?.user;

    // const handleSubmit = (data: BiometricDeviceUserRequest) => {
    //     loggedInUser && dispatch(updateBiometricDeviceUser({ ...data, id: transaction.id })).then(resp => {
    //         if (resp.meta.requestStatus === 'fulfilled') {
    //             setShowBiometricUserForm(false);
    //         }
    //     });
    // };

    const getStatusChip = (status: BiometricTransactionProcessingStatus): ReactNode => {
            switch (status) {
                case BiometricTransactionProcessingStatus.PROCESSED: {
                    return <StyledChip label={status} color="success" />
                }
                case BiometricTransactionProcessingStatus.PENDING: {
                    return <StyledChip label={status} color="info" />
                }
                case BiometricTransactionProcessingStatus.FAILED: {
                    return <StyledChip label={status} color="error" />
                }
                default: {
                    return <></>
                }
            }
        }
    

    return (
        <>
            <StyledTableRow key={transaction.id}>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">PIN</Box>{transaction.devicePin}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Punch Time</Box>{transaction.punchTime.replace('T', ' ')}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Status</Box>{getStatusChip(transaction.processingStatus as BiometricTransactionProcessingStatus)}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Processing Error</Box>{transaction.processingError || "—"}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Processed At</Box>{transaction.processedAt?.replace('T', ' ')}</TableCell>
                {/* <TableCell>
                    <TableActionButton onClick={() => setShowBiometricUserForm(true)} label="Link user" icon={<SocialDistanceIcon />} />
                </TableCell> */}
            </StyledTableRow>
            {/* {showBiometricUserForm &&
                <BiometricUserForm deviceUser={transaction} editable={true} onClose={() => setShowBiometricUserForm(false)} onSubmit={handleSubmit} />
            } */}
        </>
    );
}

export default BiometricTransactionTableRow;